var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import CircularProgress from '@mui/material/CircularProgress';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box, Button } from '@mui/material';
// defaul props
ConfirmationModal.defaultProps = {
    text: '¿Estás seguro de que quieres continuar?',
    onConfirm: function () { },
    onCancel: function () { },
};
export default function ConfirmationModal(_a) {
    var text = _a.text, onConfirm = _a.onConfirm, onCancel = _a.onCancel, error = _a.error, loading = _a.loading;
    return (_jsxs(Dialog, __assign({ open: true, onClose: onCancel, maxWidth: "xs", fullWidth: true }, { children: [_jsxs(DialogTitle, { children: [" ", error ? 'Error' : 'Confirmación'] }), _jsx(DialogContent, { children: _jsxs(_Fragment, { children: [loading &&
                            _jsx(Box, __assign({ sx: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' } }, { children: _jsx(CircularProgress, { color: "inherit" }) })), !loading &&
                            _jsx(Typography, __assign({ variant: "body2", color: "text.secondary", gutterBottom: true }, { children: error ? error : text }))] }) }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: onCancel, color: "error" }, { children: error ? 'Cerrar' : 'Cancelar' })), !error && _jsx(Button, __assign({ onClick: onConfirm, color: "primary" }, { children: "Confirmar" }))] })] })));
}
